var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocStopoverFlagBlankWhiteC84(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0_4_Icons_MIB3 / 0_4_3_IconMaster / navi / soc_stopover_flag_blank_white_C8.4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "0_4_Icons_MIB3-/-0_4_3_IconMaster-/-navi-/-soc_stopover_flag_blank_white_C8.4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "soc_destination_blank_stopover_flag",
    fill: "#999999"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,33 L15,33 L15,6 L3,6 L3,33 Z M12,4.5 L12,1.5 L6,1.5 L6,4.5 L1.5,4.5 L1.5,34.5 L16.5,34.5 L16.5,4.5 L12,4.5 Z",
    id: "battery"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.75,15 L21.75,34.5 L20.25,34.5 L20.25,15 L21.75,15 Z M23.25,15 L34.5,20.625 L23.25,24 L23.25,15 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocStopoverFlagBlankWhiteC84);
export default __webpack_public_path__ + "static/media/soc_stopover_flag_blank_white_C8.4.d951df089d7f051a673a4dcca3735f3d.svg";
export { ForwardRef as ReactComponent };